import currencyMixin from "@/mixins/currencyMixin";

export default {
  mixins: [currencyMixin],

  data() {
    return {
      tiposMeta: [
        { value: "coletiva", label: "Coletiva" },
        { value: "individual", label: "Individual" }
      ],
      tiposCalculo: [
        { value: 1, label: "Meta Fixa" },
        { value: 2, label: "Faixa Progressiva" }
      ],
      tiposPagamento: [
        { value: 1, label: "Por Unidade" },
        { value: 2, label: "Valor Fixo" }
      ]
    };
  },

  computed: {
    descricaoTipoMeta() {
      return this.form.tipoMeta === "individual"
        ? "Defina a meta para cada participante."
        : "Defina a meta que será replicada para todos os participantes.";
    },

    descricaoTipoCalculo() {
      return this.form.tipoCalculo === 1
        ? "O colaborador precisa atingir a meta definida para receber o bônus."
        : "O bônus varia conforme o desempenho. Cada faixa de realizado tem um bônus diferente, aplicado sobre a quantidade dentro daquela faixa.";
    },

    descricaoTipoPagamento() {
      return this.form.tipoPagamento === 1
        ? "O valor do bônus é multiplicado pela quantidade realizada."
        : "O colaborador recebe um valor fixo ao atingir a condição, independente da quantidade.";
    },

    descricaoTipoChassi() {
      return "O pagamento é feito ao colaborador que efetuar a venda — cada chassi só pode ser vendido uma única vez.";
    },

    // form.origemMeta so existe no fluxo de Modelo, e so faz sentido com a
    // meta do colaborador ligada; nos demais componentes que usam este mixin
    // (Indicador, Peca, Servico, Chassi) o computed simplesmente nao e exibido.
    descricaoOrigemMeta() {
      return this.form.origemMeta === 2
        ? "A meta do participante é calculada pela média dos meses de referência, com o crescimento aplicado e respeitando a meta piso."
        : "A meta do participante é informada manualmente para cada colaborador.";
    },

    // form.usaMetaColaborador so existe no fluxo de Modelo, mesma observacao acima.
    // Meta do modelo e meta do colaborador coexistem: o switch so liga/desliga
    // a segunda, a primeira e sempre avaliada por item. Explica so a camada
    // (existe uma meta propria, somando todos os modelos, que libera um bonus
    // ao ser batida) — qual e esse bonus fica a cargo de
    // descricaoOrigemBonusColaborador, exibida na linha seguinte da ajuda.
    descricaoMetaColaborador() {
      if (!this.form.usaMetaColaborador) {
        return "Cada modelo tem sua própria meta e é avaliado separadamente.";
      }
      return "Além da meta de cada modelo, o participante tem uma meta própria somando todos os modelos. Ao batê-la, o participante recebe o bônus.";
    },

    // Explica as duas opcoes de origemBonusColaborador (mesmo estilo de
    // descricaoOrigemMeta): valor informado manualmente ou percentual sobre
    // a comissao de referencia do colaborador.
    descricaoOrigemBonusColaborador() {
      return this.form.origemBonusColaborador === 2
        ? "O bônus é calculado como um percentual sobre a comissão de referência do colaborador."
        : "O bônus é um valor fixo, informado manualmente.";
    }
  },

  methods: {
    setTipoMeta(val) {
      this.$set(this.form, "tipoMeta", val);
    },
    setTipoCalculo(val) {
      this.$set(this.form, "tipoCalculo", val);
      this.$set(this.form, "valorBonus", null);
    },
    setTipoPagamento(val) {
      this.$set(this.form, "tipoPagamento", val);
    },

    // Helpers genéricos de faixas/metas coletivas (Modelo, Peça, Serviço)
    getFaixasItem(idKey) {
      const entry = this.form.metasModelos[idKey];
      return entry && entry.faixas ? entry.faixas : [];
    },

    getMetaItemValor(idKey, campo) {
      const entry = this.form.metasModelos[idKey];
      return entry ? entry[campo] : "";
    },

    setMetaItemValor(idKey, campo, valor) {
      if (!this.form.metasModelos[idKey]) {
        this.$set(this.form.metasModelos, idKey, {});
      }
      this.$set(this.form.metasModelos[idKey], campo, valor);
    },

    adicionarFaixaItem(idKey) {
      if (!this.form.metasModelos[idKey]) {
        this.$set(this.form.metasModelos, idKey, { faixas: [] });
      } else if (!this.form.metasModelos[idKey].faixas) {
        this.$set(this.form.metasModelos[idKey], "faixas", []);
      }
      this.form.metasModelos[idKey].faixas.push({ minimo: "", maximo: "", bonus: "" });
    },

    removerFaixaItem(idKey, idx) {
      this.form.metasModelos[idKey].faixas.splice(idx, 1);
    },

    atualizarFaixaItem(idKey, idx, campo, valor) {
      this.$set(this.form.metasModelos[idKey].faixas[idx], campo, valor);
    },

    getFaixaOrdemErroItem(idKey, idx) {
      if (idx === 0) return "";
      const faixas = this.getFaixasItem(idKey);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      if (parseFloat(atual.minimo) <= parseFloat(anterior.maximo)) {
        return `Mínimo deve ser > ${anterior.maximo} (maior que o máximo da faixa anterior)`;
      }
      return "";
    },

    // Helpers para modo individual de itens (Modelo, Peça, Serviço, Chassi)
    // Usam form.metasIndividuaisItens[id_colaborador][id_item]
    getIndividualItemValor(idColaborador, idItem, campo) {
      const colData = this.form.metasIndividuaisItens && this.form.metasIndividuaisItens[idColaborador];
      return colData && colData[idItem] ? colData[idItem][campo] || "" : "";
    },

    setIndividualItemValor(idColaborador, idItem, campo, valor) {
      if (!this.form.metasIndividuaisItens[idColaborador]) {
        this.$set(this.form.metasIndividuaisItens, idColaborador, {});
      }
      if (!this.form.metasIndividuaisItens[idColaborador][idItem]) {
        this.$set(this.form.metasIndividuaisItens[idColaborador], idItem, {});
      }
      this.$set(this.form.metasIndividuaisItens[idColaborador][idItem], campo, valor);
    },

    getIndividualItemFaixas(idColaborador, idItem) {
      const colData = this.form.metasIndividuaisItens && this.form.metasIndividuaisItens[idColaborador];
      const itemData = colData && colData[idItem];
      return itemData && itemData.faixas ? itemData.faixas : [];
    },

    _ensureIndividualItem(idColaborador, idItem) {
      if (!this.form.metasIndividuaisItens[idColaborador]) {
        this.$set(this.form.metasIndividuaisItens, idColaborador, {});
      }
      if (!this.form.metasIndividuaisItens[idColaborador][idItem]) {
        this.$set(this.form.metasIndividuaisItens[idColaborador], idItem, { faixas: [] });
      } else if (!this.form.metasIndividuaisItens[idColaborador][idItem].faixas) {
        this.$set(this.form.metasIndividuaisItens[idColaborador][idItem], "faixas", []);
      }
    },

    adicionarFaixaIndividualItem(idColaborador, idItem) {
      this._ensureIndividualItem(idColaborador, idItem);
      this.form.metasIndividuaisItens[idColaborador][idItem].faixas.push({ minimo: "", maximo: "", bonus: "" });
    },

    removerFaixaIndividualItem(idColaborador, idItem, idx) {
      this.form.metasIndividuaisItens[idColaborador][idItem].faixas.splice(idx, 1);
    },

    atualizarFaixaIndividualItem(idColaborador, idItem, idx, campo, valor) {
      this._ensureIndividualItem(idColaborador, idItem);
      this.$set(this.form.metasIndividuaisItens[idColaborador][idItem].faixas[idx], campo, valor);
    },

    getFaixaOrdemErroIndividualItem(idColaborador, idItem, idx) {
      if (idx === 0) return "";
      const faixas = this.getIndividualItemFaixas(idColaborador, idItem);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      if (parseFloat(atual.minimo) <= parseFloat(anterior.maximo)) {
        return `Mínimo deve ser > ${anterior.maximo}`;
      }
      return "";
    },

    getFaixaMaximoErroIndividualItem(idColaborador, idItem, idx) {
      const faixas = this.getIndividualItemFaixas(idColaborador, idItem);
      const faixa = faixas[idx];
      if (!faixa || faixa.minimo === "" || faixa.maximo === "") return "";
      // >= e nao >: a faixa progressiva coletiva aceita faixa de valor unico
      // (de 3 ate 3), entao a individual precisa aceitar tambem.
      if (parseFloat(faixa.maximo) < parseFloat(faixa.minimo)) {
        return `Máximo deve ser >= ${faixa.minimo}`;
      }
      return "";
    }
  }
};
